import classNames from 'classnames'
import React from 'react'

export const GridElement: React.FC<{
  columns?: 1 | 2 | 3 | 4
  align?: 'left' | 'right'
  children: React.ReactNode
}> = ({ columns = 1, align = 'left', children }) => {
  const colSpans = ['col-span-1', 'col-span-2', 'col-span-3', 'col-span-4']
  const aligment = { left: 'text-left', right: 'text-right' }
  return (
    <div className={classNames(colSpans[columns - 1], aligment[align])}>
      {children}
    </div>
  )
}
